import { authService } from '@pidz/api';
import { DateTime } from 'luxon';

let lastTokenResult: any = null;
let refreshPromise: any = null;

const sessionSecondsLeft = (expiresAt: number) =>
  (expiresAt - DateTime.now().toMillis()) / 1000;

const checkRefresh = async () => {
  const secondsLeft = lastTokenResult
    ? sessionSecondsLeft(lastTokenResult.expiresAt)
    : 0;
  if (secondsLeft < 60) {
    lastTokenResult = (await authService.refreshTokens()).data;
  }
};

export const getAutorizationHeaders = () => {
  if (lastTokenResult) {
    return { Authorization: `Bearer ${lastTokenResult.accessToken}` };
  }
  return {};
};

export const redirectToLogin = () => {
  const { VITE_ACC_ZZP_BASE_URL, VITE_ADMIN_URL } = import.meta.env;
  window.parent.location = `${VITE_ACC_ZZP_BASE_URL}/login?redirect_uri=${VITE_ADMIN_URL}`;
};

export const freshToken = async () => {
  if (refreshPromise) {
    await refreshPromise;
  } else {
    refreshPromise = checkRefresh();
    await refreshPromise;
    refreshPromise = null;
  }
};

export const logOut = async () => {
  await authService.logout();
};
